export class CreateSnapshotRecipeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recipe",
            "baseName": "recipe",
            "type": "SnapshotRecipe",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSnapshotRecipeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
